import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import style from './switch-button.scss';

@CSSModules(style)
export default class SwitchButton extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    formFieldName: PropTypes.string,
    formFieldLabel: PropTypes.string,
    setType: PropTypes.func,
    getFormValue: PropTypes.func
  };

  handleChange(e) {
    this.handleElementChange(e.target);
  }

  handleElementChange(el) {
    if (this.context.onChange) {
      this.context.onChange(this.context.formFieldName, el.checked);
    }
  }

  componentDidMount() {
    this.handleElementChange(this.refs.element);
  }

  componentWillMount() {
    if (this.context.setType) this.context.setType('SwitchButton');
  }

  render() {
    const name = this.context.formFieldName;
    const value = this.context.getFormValue(name);

    return (
      <label styleName="root">
        <input
          ref="element"
          type="checkbox"
          onChange={::this.handleChange}
          checked={!!value}
        />
        <span styleName="checkbox" />
        <span styleName="label">
          {this.context.formFieldLabel}
        </span>
      </label>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/switch-button.js